import React, { useEffect, useState } from "react";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, User } from "iconsax-reactjs";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Layout from "../components/layout";
import LoadingSpinner from "../components/common/LoadingSpinner";

const NotificationPage = () => {
  const [invites, setInvites] = useState([]);
  const [pendingTasks, setPendingTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return navigate("/login");

    fetchAllNotifications(user._id, user.token);
  }, []);

  const fetchAllNotifications = async (userId, token) => {
    try {
      const resInvites = await httpReauest(
        "GET",
        `/user/friends/invite/${userId}`,
        {},
        { "x-access-token": token }
      );

      const resTasks = await httpReauest(
        "GET",
        `/task/pending/${userId}`,
        {},
        { "x-access-token": token }
      );

      setInvites(resInvites.data.data || []);
      setPendingTasks(resTasks.data.data || []);
    } catch (error) {
      toast.error(t("error_loading_notifications"));
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptInvite = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "POST",
        `/user/accept/friend`,
        { friendId: id },
        { "x-access-token": user?.token }
      );
      fetchAllNotifications(user._id, user.token);
    } catch (error) {
      toast.error(t("error_accepting_invite"));
    }
  };

  const handleRejectInvite = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "DELETE",
        `/user/accept/friend`,
        { friendId: id },
        { "x-access-token": user?.token }
      );
      fetchAllNotifications(user._id, user.token);
    } catch (error) {
      toast.error(t("error_rejecting_invite"));
    }
  };

  const handleVerifyTask = async (submissionId) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "POST",
        "/task/verify",
        {
          submissionId,
          verifierId: user._id,
        },
        { "x-access-token": user.token }
      );
      toast.success(t("task_verified"));
      fetchAllNotifications(user._id, user.token);
    } catch (error) {
      toast.error(t("task_verify_failed"));
    }
  };

  const handleRejectTask = async (submissionId) => {
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      await httpReauest(
        "POST",
        "/task/reject",
        {
          submissionId,
          verifierId: user._id,
        },
        { "x-access-token": user.token }
      );
      toast.success(t("task_rejected"));
      fetchAllNotifications(user._id, user.token);
    } catch (error) {
      toast.error(t("task_reject_failed"));
    }
  };

 if (loading) {
    return <LoadingSpinner />;
  }


  return (
    <div className="min-h-screen flex flex-col pb-[62px]">
      <Layout>
        <div className="flex items-center gap-3 px-4 py-4 border-b bg-white shadow">
          <Link to="/profile" className="text-[var(--primary)]">
            <ArrowLeft />
          </Link>
          <h1 className="text-lg font-bold">{t("nav_notification")}</h1>
        </div>

        <div className="px-4 py-6 space-y-8">
          {/* درخواست‌های دوستی */}
          <div>
            <h2 className="text-md font-semibold mb-2">{t("invites")}</h2>
            {invites.length > 0 ? (
              invites.map((invite) => (
                <div
                  key={invite._id}
                  className="p-3 bg-white rounded shadow flex justify-between items-center"
                >
                  <div>
                    <h4 className="font-bold">{invite?.userId?.name}</h4>
                    <p className="text-[14px] text-gray-600">
                      {invite?.userId?.email || invite?.userId?.phone}
                    </p>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => handleAcceptInvite(invite._id)}
                      className="px-3 py-1 text-white bg-green-500 rounded text-sm"
                    >
                      {t("accept")}
                    </button>
                    <button
                      onClick={() => handleRejectInvite(invite._id)}
                      className="px-3 py-1 text-white bg-red-500 rounded text-sm"
                    >
                      {t("reject")}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500">{t("no_invites")}</p>
            )}
          </div>

          {/* درخواست‌های تأیید تسک */}
          <div>
            <h2 className="text-md font-semibold mb-2">
              {t("tasks_to_verify")}
            </h2>
            {pendingTasks.length > 0 ? (
              pendingTasks.map((task) => (
                <div
                  key={task._id}
                  className="p-3 bg-yellow-100 gap-2 rounded shadow flex justify-between items-center"
                >
                  <div>
                    <h4 className="font-bold">
                      {t("task_verification_invite", {
                        name: task?.userId?.name,
                        stage: task.stage + 1,
                      })}
                    </h4>
                    <p className="text-sm text-gray-700">
                      {i18n.language === "ar" ? task.task : task.task_en}
                    </p>
                  </div>
                  <span className="flex gap-2 items-center">
                    <button
                      onClick={() => handleRejectTask(task._id)}
                      className="px-3 py-1 bg-red-600 text-white rounded text-sm"
                    >
                      {t("cancel")}
                    </button>

                    <button
                      onClick={() => handleVerifyTask(task._id)}
                      className="px-3 py-1 bg-green-600 text-white rounded text-sm"
                    >
                      {t("verify")}
                    </button>
                  </span>
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500">{t("no_tasks_to_verify")}</p>
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default NotificationPage;
